export class UserLocationLayerHook {
}
